import { useMutation, useQueryClient } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface UpdateArtifactPasswordVariables {
  id: string;
  password?: string;
  removePassword?: boolean;
  accessLevel?: 'public' | 'client' | 'internal';
}

export const useUpdateArtifactPassword = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, password, removePassword, accessLevel }: UpdateArtifactPasswordVariables) => {
      const body: Record<string, unknown> = {};
      if (removePassword) body.removePassword = true;
      else if (password !== undefined) body.password = password;
      if (accessLevel) body.accessLevel = accessLevel;

      const response = await fetchAPI({
        method: 'PUT',
        route: `artifacts/${id}/password`,
        data: body
      });
      if (response.code >= 400) {
        throw response;
      }
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['artifacts'] });
    }
  });
};

export default useUpdateArtifactPassword;
